import slidesLVLO1 from './slides_LVLO1';
import { featuresLVLO1 } from './features_LVLO1';
import { ProjectType } from '../../Constants';
import { textLVLO1 } from './text_LVLO1';

export const LVLO1data = {
    fr: {
        id: 4,
        name: 'LeVIVO longueuil 1',
        content: textLVLO1.fr,
        yearBuilt: 2018,
        address: "55 Rue de l'Église, Longueuil, QC J4G 1H8",
        city: "Longueuil",
        brand: "levivo",
        projectPage: "levivo/longueuil-1",
        website: "https://levivo.ca/en/rentals-condos/levivo-longueuil-1/",
        category: ProjectType.Residential,
        images: slidesLVLO1,
        features: featuresLVLO1.fr
    },
    en: {
        id: 4,
        name: 'LeVIVO longueuil 1',
        content: textLVLO1.en,
        yearBuilt: 2018,
        address: "55 Rue de l'Église, Longueuil, QC J4G 1H8",
        city: "Longueuil",
        brand: "levivo",
        projectPage: "levivo/longueuil-1",
        website: "https://levivo.ca/en/rentals-condos/levivo-longueuil-1/",
        category: ProjectType.Residential,
        images: slidesLVLO1,
        features: featuresLVLO1.en
    }
}
